import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'visible',
  },
  modal: {
    backgroundColor: colors.white,
    borderRadius: 8,
    padding: 64,
    width: '100%',
    maxHeight: '95%',
    minHeight: 200,
  },
  closeButton: {
    position: 'absolute',
    top: 24,
    right: 24,
  },
  title: {
    fontWeight: 600,
    fontSize: 20,
    marginBottom: 16,
    fontFamily: 'InterSemiBold',
    maxWidth: '80%',
  },
  singleActionButton: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 20,
  },
  actionButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 20,
  },
});
